import { useEffect, useState } from 'react';
import './Banner.css';

const IMAGES = [
  '/painel/painel1.png',
  '/painel/painel2.png',
  '/painel/painel3.png',
  '/painel/painel4.png',
  '/painel/painel5.png',
  '/painel/painel6.png',
];

export default function Banner() {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const timer = window.setInterval(() => {
      setIndex(prev => (prev + 1) % IMAGES.length);
    }, 6000);
    return () => window.clearInterval(timer);
  }, []);

  return (
    <section className="banner" aria-label="Banner principal">
      {IMAGES.map((src, i) => (
        <div
          key={src}
          className={`banner-slide ${i === index ? 'active' : ''}`}
          style={{ backgroundImage: `url(${src})` }}
          aria-hidden={i !== index}
        />
      ))}
      <div className="banner-dots">
        {IMAGES.map((_, i) => (
          <button
            key={i}
            type="button"
            className={i === index ? 'active' : ''}
            onClick={() => setIndex(i)}
            aria-label={`Slide ${i + 1}`}
          />
        ))}
      </div>
    </section>
  );
}
